
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Manyseaterbuses() {



    const cardData =
    {
        keyword: '32,35,40,45,50 Seater Bus on Rent in Pune',
        heading: 'Amruta Travels: 32,35,40,45,50 Seater Bus on Rent in Pune',
        headingDescription: 'Amruta Travels offers 32, 35, 40, 45, and 50 Seater Bus on Rent in Pune, providing flexible and comfortable travel options for medium to large groups. Whether it is for school trips, weddings, corporate outings, religious tours, or family functions, we have the perfect bus to match your group size and travel needs. Our fleet is clean, well-maintained, and driven by experienced chauffeurs who prioritize safety and punctuality. With 24/7 availability, competitive pricing, and dedicated customer service, Amruta Travels ensures your group journey in and around Pune is smooth, safe, and convenient. Book your bus today for a worry-free travel experience!',


        top: 'Top Places to Visit in Pune with Amruta Travels',
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



    "services": [
    {
      "name": "32 Seater Bus Hire Near Me in Pune",
      "description": "Amruta Travels offers reliable 32-seater bus rentals for group travel in Pune. Whether for a family trip, office outing, or any other group travel, our well-maintained buses provide comfort and safety."
    },
    {
      "name": "32 Seater Bus Hire for Outstation in Pune",
      "description": "For outstation trips, rent a 32-seater bus with Amruta Travels. Ideal for family holidays, corporate trips, and group tours, our buses offer AC and Non-AC options with professional drivers."
    },
    {
      "name": "32 Seater Bus Rate Per Km in Pune",
      "description": "Amruta Travels offers competitive per kilometer rates for 32-seater bus rentals in Pune. We provide clear pricing and flexible travel options for local and outstation trips."
    },
    {
      "name": "35 Seater Bus on Rent in Pune",
      "description": "Rent a 35-seater bus for your group trips in Pune with Amruta Travels. Perfect for family outings, corporate events, or religious tours, our buses are equipped with comfortable seating and air conditioning."
    },
    {
      "name": "35 Seater Tourist Bus Near Me in Pune",
      "description": "Looking for a 35-seater tourist bus near you? Amruta Travels provides buses for group travel, offering both comfort and convenience for local and outstation trips in Pune."
    },
    {
      "name": "35 Seater Tourist Bus for Outstation in Pune",
      "description": "Amruta Travels offers 35-seater tourist buses for outstation trips from Pune. Explore new destinations comfortably, with a well-maintained fleet, experienced drivers, and the option for both AC and Non-AC buses."
    },
    {
      "name": "35 Seater Bus for Corporate Office in Pune",
      "description": "Book a 35-seater bus for corporate office outings in Pune with Amruta Travels. We offer spacious buses for team-building activities, seminars, or business trips, providing a comfortable travel experience."
    },
    {
      "name": "35 Seater Bus for Corporate Outing in Pune",
      "description": "Plan your corporate outing with Amruta Travels' 35-seater buses. Perfect for team trips, corporate events, or client visits, our buses come with all amenities to ensure a smooth, comfortable ride."
    },
    {
      "name": "40 Seater Tourist Bus Near Me Pune",
      "description": "Amruta Travels provides 40-seater tourist buses for your trips in Pune. Whether for group sightseeing, corporate events, or family outings, our buses ensure a comfortable journey with modern amenities."
    },
    {
      "name": "40 Seater Bus Rent Per Km in Pune",
      "description": "Rent a 40-seater bus in Pune with Amruta Travels at competitive rates. We provide transparent pricing based on distance and offer both AC and Non-AC buses for all your group travel needs."
    },
    {
      "name": "40 Seater Bus on Rent in Pune",
      "description": "Amruta Travels offers 40-seater buses for rent in Pune, ideal for larger groups. Whether for religious tours, family trips, or corporate outings, our buses are designed for comfort and safety."
    },
    {
      "name": "40 Seater Bus on Rent in Pune for Wedding",
      "description": "Looking for a bus for wedding transportation in Pune? Rent a 40-seater bus from Amruta Travels to transport guests comfortably to and from wedding venues, with AC options and ample space for luggage."
    },
    {
      "name": "45 Seater Bus Near Me for Rent",
      "description": "Rent a 45-seater bus with Amruta Travels for large group trips in and around Pune. Our buses are ideal for school trips, corporate events, and group sightseeing tours, ensuring a comfortable and safe ride."
    },
    {
      "name": "45 Seater Bus for School Trip",
      "description": "Book a 45-seater bus for school trips in Pune with Amruta Travels. Our buses are equipped with safety features and offer a comfortable travel experience for students and staff, ensuring timely arrivals."
    },
    {
      "name": "45 Seater Bus Price Per Km in Pune",
      "description": "Amruta Travels offers competitive pricing for 45-seater bus rentals in Pune. Our per-kilometer rates are transparent, offering a cost-effective solution for large group travel both locally and outstation."
    },
    {
      "name": "50 Seater Bus Rental Services in Pune",
      "description": "Amruta Travels provides 50-seater buses for rent in Pune, catering to large groups. Perfect for corporate events, weddings, school excursions, or family outings, our buses offer comfort and punctuality."
    },
    {
      "name": "50 Seater Bus for Corporate Outing Near Me",
      "description": "For corporate outings near you, rent a 50-seater bus with Amruta Travels. Our buses are equipped with all the amenities required for a smooth journey, making them ideal for team-building events and client meetings."
    },
    {
      "name": "50 Seater Bus Hire in Pune",
      "description": "Amruta Travels offers 50-seater buses for hire in Pune, suitable for larger groups. With options for both local and outstation trips, our buses ensure a comfortable travel experience with professional drivers."
    }
  ],
  "tableData": [
    ["32 Seater Bus Hire Near Me in Pune", "32 Seater Bus Hire for Outstation in Pune"],
    ["32 Seater Bus Rate Per Km in Pune", "35 Seater Bus on Rent in Pune"],
    ["35 Seater Tourist Bus Near Me in Pune", "35 Seater Tourist Bus for Outstation in Pune"],
    ["35 Seater Bus for Corporate Office in Pune", "35 Seater Bus for Corporate Outing in Pune"],
    ["40 Seater Tourist Bus Near Me Pune", "40 Seater Bus Rent Per Km in Pune"],
    ["40 Seater Bus on Rent in Pune", "40 Seater Bus on Rent in Pune for Wedding"],
    ["45 Seater Bus Near Me for Rent", "45 Seater Bus for School Trip"],
    ["45 Seater Bus Price Per Km in Pune", "50 Seater Bus Rental Services in Pune"],
    ["50 Seater Bus for Corporate Outing Near Me", "50 Seater Bus Hire in Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Wide Range of Bus Options for Every Group Size",
    "WhyChoosedescription": "Amruta Travels offers 32, 35, 40, 45, and 50 Seater Bus on Rent in Pune, catering to all types of group travel needs. Whether you’re planning a school trip, corporate outing, wedding, pilgrimage, or sightseeing tour, we have the right size bus to ensure your group travels together comfortably. From mid-size to large groups, our fleet is equipped to accommodate all your travel requirements efficiently."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Seating",
    "WhyChoosedescription": "Our buses are designed for comfort with spacious seating, generous legroom, clean interiors, and air conditioning for a relaxed ride. No matter which size you choose—32, 35, 40, 45, or 50 seater—you’ll enjoy a smooth and comfortable journey with plenty of space for passengers and luggage. Ideal for long journeys or full-day travel within and beyond Pune."
  },
  {
    "WhyChooseheading": "Ideal for Events, Excursions, and Outstation Travel",
    "WhyChoosedescription": "Whether it's a wedding function, a school excursion, a religious tour, or a corporate retreat, our range of seater buses ensures there's a perfect fit for your event. Each vehicle is maintained for long-distance comfort and is suitable for outstation trips from Pune to destinations like Shirdi, Mahabaleshwar, Nashik, Goa, and more."
  },
  {
    "WhyChooseheading": "Experienced Drivers Ensuring Safety and Reliability",
    "WhyChoosedescription": "All our drivers are experienced, licensed, and well-trained to provide safe, punctual, and professional service. With in-depth knowledge of Pune routes and outstation highways, our drivers ensure smooth transit while maintaining high safety standards. They are courteous and responsive to group needs throughout the trip."
  },
  {
    "WhyChooseheading": "Affordable, Transparent Pricing Across All Bus Sizes",
    "WhyChoosedescription": "We offer competitive and transparent pricing for all bus sizes—32, 35, 40, 45, and 50 seater options. No hidden charges or last-minute surprises. Our clear pricing model allows you to plan your budget with confidence, whether you’re booking for a few hours or multiple days."
  },
  {
    "WhyChooseheading": "Well-Maintained Fleet with Regular Servicing",
    "WhyChoosedescription": "Every bus in our fleet undergoes regular maintenance and cleanliness checks to ensure top-tier performance and hygiene. From upholstery to air conditioning, each element is checked before dispatch. You can trust Amruta Travels for clean, safe, and fully serviced buses for your journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off Across Pune",
    "WhyChoosedescription": "We provide doorstep pickup and drop-off at any location in Pune. Be it your home, school, office, or event venue—we adapt to your schedule. This flexibility ensures maximum convenience and seamless coordination, especially for large groups and time-sensitive events."
  },
  {
    "WhyChooseheading": "Quick Booking and Dedicated Customer Support",
    "WhyChoosedescription": "Booking a 32 to 50 seater bus in Pune with Amruta Travels is quick, easy, and reliable. You can book through our website, call our helpline, or visit us in person. Our customer support team is available to assist with itinerary planning, vehicle selection, pricing, and special requirements to ensure a stress-free experience."
  }
]
















    }

const faqData = [
  {
    question: 'How can I rent a 32, 35, 40, 45, or 50 seater bus in Pune?',
    answer: 'Renting a bus of any size in Pune with Amruta Travels is easy. You can book online, call our team, or visit our office. We’ll help you choose the right bus based on your group size and trip type.',
  },
  {
    question: 'What are the features of 32 to 50 seater buses?',
    answer: 'Our buses from 32 to 50 seaters come with comfortable push-back seats, air conditioning, spacious interiors, and ample luggage space. Luxury options offer added amenities like entertainment systems and premium seating.',
  },
  {
    question: 'For what purposes can I rent these buses?',
    answer: 'These buses are perfect for weddings, school trips, corporate events, local sightseeing, outstation journeys, and family group travel. We tailor the service based on your specific event or itinerary.',
  },
  {
    question: 'Are the buses available for outstation trips from Pune?',
    answer: 'Yes, all our buses are available for outstation trips from Pune to destinations like Shirdi, Nashik, Mumbai, Goa, Mahabaleshwar, and more. We ensure safe and comfortable long-distance travel.',
  },
  {
    question: 'Can I use these buses for local travel in Pune?',
    answer: 'Absolutely. Our 32 to 50 seater buses are available for local travel including weddings, city tours, school trips, and corporate shuttle services within Pune.',
  },
  {
    question: 'How much does it cost to rent a 32 to 50 seater bus in Pune?',
    answer: 'The cost varies based on the bus size, travel distance, trip duration, and amenities required. Contact us with your travel details for a transparent and customized quote.',
  },
  {
    question: 'Are your buses sanitized and maintained regularly?',
    answer: 'Yes, we prioritize safety and cleanliness. All our buses are regularly sanitized and undergo scheduled maintenance to ensure a hygienic and smooth travel experience.',
  },
  {
    question: 'Do you provide experienced drivers with the buses?',
    answer: 'Yes, all our rentals include skilled and licensed drivers who are punctual, courteous, and familiar with local and outstation routes.',
  },
  {
    question: 'Why choose Amruta Travels for large bus rentals in Pune?',
    answer: 'Amruta Travels is known for reliable service, well-maintained buses, trained drivers, and flexible booking. We focus on comfort, safety, and customer satisfaction for every trip.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Sandeep Kulkarni',
    role: 'Wedding Planner, Pune',
    text: 'We hired a 50 seater bus for wedding guests from Amruta Travels. It was clean, spacious, and the guests were very comfortable. Excellent service and punctuality!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Manisha Raut',
    role: 'School Trip Coordinator, Pune',
    text: 'We used both 35 and 45 seater buses for our school picnic. The children and staff had a safe and smooth ride. The drivers were cooperative and the buses were in great condition.',
    rating: 5,
  },
  {
    id: 3,
    name: 'Mr. Harshad Mehta',
    role: 'Corporate Manager, Pune',
    text: 'Amruta Travels provided a 40 seater bus for our company offsite. The service was professional, the bus was comfortable, and the whole journey went perfectly.',
    rating: 5,
  },
];



















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "32, 35, 40, 45, 50 Seater Bus on Rent in Pune",
  "image": "https://bushireinpune.com/assets/images/32-50-seater-bus-on-rent-in-pune.jpg",
  "description": "Book 32, 35, 40, 45, and 50 seater buses on rent in Pune for weddings, corporate outings, school trips, and outstation travel. Affordable per-km pricing. AC and non-AC tourist buses available near you for local and long-distance journeys. Reliable service from Amruta Travels.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "13025"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3999",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/32-50-seater-bus-on-rent-in-pune"
  }
};





    return (
        <div>


<Helmet>
  <title>Call: +91 7353109555 | 32–50 Seater Bus on Rent in Pune | Tourist, Wedding & Corporate | Amruta Travels</title>
  <meta 
    name="description" 
    content="Hire 32, 35, 40, 45 & 50 seater buses in Pune for weddings, corporate events, school trips & outstation travel. Affordable rates per km. AC & non-AC tourist buses near you. Book with Amruta Travels." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/37.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Manyseaterbuses;